"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLineOfCoverageOptions = void 0;
var differenceBy_1 = __importDefault(require("lodash/differenceBy"));
var react_1 = require("react");
var line_of_coverage_type_option_1 = require("../../utils/line-of-coverage-type-option");
var definitions_1 = require("../definitions");
var helpers_1 = require("./helpers");
function useLineOfCoverageOptions(_a, config) {
    var policyType = _a.policyType, selectAllByDefault = _a.selectAllByDefault, selectedOptions = _a.selectedOptions, selectOptions = _a.selectOptions;
    var _b = react_1.useState(true), selectAllByDefaultDone = _b[0], setSelectAllByDefaultDone = _b[1];
    var _c = react_1.useState([]), options = _c[0], setOptions = _c[1];
    var _d = definitions_1.useDefinitionsHelpers({}, config), loading = _d.loading, error = _d.error, policyTypeDefinitions = _d.policyTypeDefinitions;
    var defaultOptionsForPolicyType = react_1.useMemo(function () { var _a, _b; return line_of_coverage_type_option_1.typesToOptions((_b = (_a = policyTypeDefinitions[policyType]) === null || _a === void 0 ? void 0 : _a.locs) !== null && _b !== void 0 ? _b : []); }, [policyTypeDefinitions, policyType]);
    react_1.useEffect(function () {
        setOptions(function () { return helpers_1.calculateOptions(defaultOptionsForPolicyType, selectedOptions); });
    }, [defaultOptionsForPolicyType, selectedOptions]);
    react_1.useEffect(function () { return setSelectAllByDefaultDone(false); }, [policyType]);
    // defaultOptionsForPolicyType should start selected if selectAllByDefault is enabled:
    react_1.useEffect(function () {
        if (!selectAllByDefault || selectAllByDefaultDone)
            return;
        setSelectAllByDefaultDone(true);
        var unselectedOptions = differenceBy_1.default(options, selectedOptions, function (_a) {
            var id = _a.id;
            return id;
        });
        if (unselectedOptions.length > 0) {
            selectOptions(options);
        }
    }, [selectAllByDefault, selectAllByDefaultDone, selectOptions, options, selectedOptions]);
    function addOption(type) {
        var newOption = line_of_coverage_type_option_1.calculateNewOption(options, type);
        setOptions(helpers_1.add(options, newOption));
        selectOptions(helpers_1.add(selectedOptions, newOption));
    }
    function selectOption(option) {
        selectOptions(helpers_1.add(selectedOptions, option));
    }
    function unselectOption(option) {
        selectOptions(helpers_1.remove(selectedOptions, option));
    }
    return {
        loading: loading,
        error: error,
        options: options,
        addOption: addOption,
        selectOption: selectOption,
        unselectOption: unselectOption,
    };
}
exports.useLineOfCoverageOptions = useLineOfCoverageOptions;
